import img1b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1b.webp';
import img1c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1c.webp';
import img1d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1d.webp';
import img1e from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1e.webp';
import img1f from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1f.webp';
import img1i from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1i.webp';
import img1j from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/1j.webp';

import img2a from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2a.webp';
import img2b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2b.webp';
import img2c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2c.webp';
import img2d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2d.webp';
import img2e from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2e.webp';
import img2f from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2f.webp';
import img2g from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2g.webp';
import img2h from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2h.webp';
import img2i from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2i.webp';
import img2j from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2j.webp';
import img2k from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2k.webp';
import img2m from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2m.webp';
import img2n from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2n.webp';
import img2o from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2o.webp';
import img2p from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2p.webp';
import img2r from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2r.webp';
import img2s from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2s.webp';
import img2t from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2t.webp';
import img2u from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2u.webp';
import img2v from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2v.webp';
import img2w from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/2w.webp';

import img3a from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3a.webp';
import img3b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3b.webp';
import img3c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3c.webp';
import img3d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3d.webp';
import img3e from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3e.webp';
import img3f from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3f.webp';
import img3g from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3g.webp';
import img3h from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3h.webp';
import img3j from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/3j.webp';

import img4b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4b.webp';
import img4d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4d.webp';
import img4e from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4e.webp';
import img4f from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4f.webp';
import img4g from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4g.webp';
import img4h from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4h.webp';
import img4j from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4j.webp';
import img4k from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/4k.webp';

import img5a from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/5a.webp';
import img5b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/5b.webp';
import img5c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/5c.webp';

import img6b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/6b.webp';
import img6c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/6c.webp';

import img7a from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/7a.webp';
import img7c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/7c.webp';
import img7d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/7d.webp';

import img8b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/8b.webp';
import img8c from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/8c.webp';
import img8d from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/8d.webp';
import img8e from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/8e.webp';

import img9a from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/9a.webp';
import img9b from '../../../images/knbf-skjema/motorbat-beregnet-for-overnatting/9b.webp';

const motorBatBeregnetForOvernatting = {
	title: 'Motorbåt beregnet for overnatting',
	logo: 'knbf',
	formDescription: 'Større motorbåt beregnet for overnatting, også RIB.',
	tableQuestions: [
		{ header: '1. Er båten tett og fri for vann' },
		{
			text: 'A. På land – skrogets utside',
			legendIcon: 'y',
			modalContent: <p>Kontroller at skroget er fritt for alvorlige skader.</p>
		},
		{
			text: 'B. På land – bunn-/lenseplugger (hvis slik finnes)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter fast før sjøssetting. Pluggene kan være slitt eller sprukket. Noen har en pakning som bør kontrolleres årlig. Byttes ved behov.<img src={img1b}/></p>
		},
		{
			text: 'C. På land – Kontroller at skroggjennomføringer er tette',
			legendIcon: 'y',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger samt selvslukningsventiler. På land, utsiden – kontroller ved å skrape bort bunnstoff og belegg at det ikke er noen tegn på korrosjon, sprekker, rust eller sprekker mellom gjennomføringens flens og skroget. Hvis en kuleventil har vært stengt gjennom vinteren, er det en risiko for at den har fryst og sprukket. I tilfelle lynnedslag kan plastgjennomføringer for navigasjonsinstrumenter ha blitt skadet. På land, innsiden – kontroller at skroggjennomføringen sitter fast, ikke har korrosjonsskader eller viser tegn på lekkasje. Kontroller at slangene ikke har sprekker eller er utslitt, samt at kranen sitter fast og ikke er rusten. Tynne spiralformede plastslanger er uegnet til skroggjennomføringer. Slanger skal, i henhold til gjeldende regelverk, under eller nær vannlinjen være festet til skroggjennomføringen med doble slangeholdere i rustfritt stål, som er vendt mot hverandre. Ventilen skal betjenes av og til for å unngå at den setter seg fast, og den skal være lett å åpne/stenge.<img src={img1c}/></p>
		},
		{
			text: 'D. På land – Lensepumpe(r)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at slangene er hele og i god stand, at det ikke er sprekker i den manuelle lensepumpens gummimembran, at sugslangen er utstyrt med sil der den suger i kjølsvinet, og at silen ikke er tett. Kontroller at håndtaket på den manuelle lensepumpen er lett tilgjengelig og passer godt i pumpens uttak. Kontroller at den elektriske lensepumpen fungerer.<img src={img1d}/></p>
		},
		{
			text: 'E. På land – Selvlensende cockpit (hvis slik finnes)',
			legendIcon: 'y',
			modalContent: <p>Fungerer avrenningen? Er eventuelle slanger ordentlig festet? På båter der selvlensingen munner ut under vannlinjen, skal det alltid være en avstengningsventil. Går den lett å åpne, og er den tett når den er stengt?<img src={img1e}/></p>
		},
		{
			text: 'F. På land – Akterdelen RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller skjøten på akterdelen for å sikre at den ikke sitter løst eller har åpnet seg. Slipp ut litt luft og klem sammen materialet ved skjøtene, og kontroller at du ikke ser tråden eller nettet som holder materialet sammen. Hvis det er synlig, er det en risiko for at hull kan oppstå. I noen tilfeller kan dette repareres, ellers må tuben byttes.<img src={img1f}/></p>
		},
		{
			text: 'G. På land – Limingen av tubene mot skroget på RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at limingen mellom tubene og skroget ikke viser tegn på at den har løsnet.</p>
		},
		{
			text: 'H. På land – Sprekker i tubene på RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det ikke er noen sprekker eller skader i materialet.</p>
		},
		{
			text: 'I. På land – Skjøter og sammenføyningssteder på RIB',
			legendIcon: 'y',
			modalContent: <p>Kontroller at tubene, alle skjøter og sammenføyningssteder ser hele ut og ikke lekker. Lekkasje kan lokaliseres ved å dyppe en svamp i vann blandet med oppvaskmiddel og stryke over tubene. Ved lekkasjestedet vil det dannes luftbobler.<img src={img1i}/></p>
		},
		{
			text: 'J. I sjøen – Kontroller at skroggjennomføringer er tette',
			legendIcon: 'm',
			modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner) og slanger, navigasjonsinstrumenter med kabeltilkoblinger samt selvslukningsventiler. I sjøen – kontroller at det ikke er noen tegn på lekkasje ved skroggjennomføringen, og at det er helt tørt rundt gjennomføringens flensmutter, ventilens gjenger og slangetilkoblinger. Ventilen skal betjenes av og til for å unngå at den setter seg fast, og den skal være lett å åpne/stenge.<img src={img1j}/></p>
		},
		{
			text: 'K. I sjøen – Løft alle dørker',
			legendIcon: 'm',
			modalContent: <p>Kontroller at det ikke er vann under dørkene eller i kjølsvinet. Sørg for at det er rent og tørt i kjølsvinet/motorrommet for å kunne oppdage lekkasjer raskt.</p>
		},
		{
			text: 'L. I sjøen – Kontroller tubene på RIB',
			legendIcon: 'b',
			modalContent: <p>Kontroller at det ikke er noen lekkasjer eller skader på tubene.</p>
		},

		{ header: '2. Sikkerhetsutstyr' },
		{
			text: 'A. Anker',
			legendIcon: 'y',
			modalContent: <p>Det finnes en rekke ulike typer anker i forskjellige størrelser og for ulike bunnforhold. Tilpass etter båtens størrelse og ankringsdybde, inkludert en margin for uforutsett nødankring. Kontroller tauets/kjettingens tilstand og at sjaklene er godt strammet og sikret. Hvis du har et ankerspill av noe slag, bør du ha som vane å feste tampens endepunkt i båten.<img src={img2a}/></p>
		},
		{
			text: 'B. Reserveanker og drivanker',
			legendIcon: 'y',
			modalContent: <p>Anbefales å ha om bord og lett tilgjengelig.<img src={img2b}/></p>
		},
		{
			text: 'C. Bade-/redningsleider',
			legendIcon: 'y',
			modalContent: <p>Minst 560 mm under vannlinjen. Kontroller at du faktisk klarer å klatre opp, og at du kan felle den ned mens du ligger i vannet.<img src={img2c}/></p>
		},
		{
			text: 'D. Taukveiler for slep og lignende',
			legendIcon: 'm',
			modalContent: <p>Tilpasses etter båtens størrelse. Kontroller at tauene er lett tilgjengelige og ikke er sammenfiltrede.<img src={img2d}/></p>
		},
		{
			text: 'E. Røykvarsler',
			legendIcon: 'm',
			modalContent: <p>Kontroller og test røykvarsleren og batteriene i henhold til leverandørens anvisninger.<img src={img2e}/></p>
		},
		{
			text: 'F. Brannteppe / Brannslukker',
			legendIcon: 'm',
			modalContent: <p>Kontroller at brannteppet ligger i etuiet, er helt, og at du vet hvor det er når du trenger det. Sjekk at manometeret står på grønt, at slangen er hel, plomberingen er intakt, og se etter siste kontroll- eller utløpsdato. Snu slukkeren noen ganger og slå lett på siden mens du “lytter” for å forsikre deg om at pulveret beveger seg fritt inne i slukkeren. Hvis båten har litiumbatterier om bord, kreves spesielle brannslukkere. Sjekk kravene fra forsikringsselskapet ditt.<img src={img2f}/></p>
		},
		{
			text: 'G. Brannslukker i motorrom',
			legendIcon: 'y',
			modalContent: <p>Brann i motorrommet skal kunne slukkes uten at luker åpnes. Dette kan løses med et sprinklersystem eller et annet fastmontert slukkesystem i motorrommet, eller med et hull i motorluken/motorpanseret der slangen fra en håndslukker kan føres inn.<img src={img2g}/></p>
		},
		{
			text: 'H. Båthake/bøyehåndtak',
			legendIcon: 'm',
			modalContent: <p>Kontroller at krok og lignende sitter fast, spesielt viktig med båthaker i teleskoputførelse.<img src={img2h}/></p>
		},
		{
			text: 'I. CE-merking/blå skilt',
			legendIcon: 'y',
			modalContent: <p>Angir blant annet maks antall personer om bord, maks last og maks motorstyrke.<img src={img2i}/></p>
		},
		{
			text: 'J. Fendere',
			legendIcon: 'm',
			modalContent: <p>Minst 4 stk anbefales (tilpasset båtens størrelse)<img src={img2j}/></p>
		},
		{
			text: 'K. Flytevester eller flyteplagg',
			legendIcon: 'b',
			modalContent: <p>Skal alltid finnes om bord og brukes av alle ombord. Flytevestene skal være CE-merket. Bruk grengrep hvis det finnes. Vedlikehold oppblåsbare modeller i henhold til produsentens anbefalinger.<img src={img2k}/></p>
		},
		{
			text: 'L. Fremdrift i reserve ved kun én motor',
			legendIcon: 'y',
			modalContent: <p>Avhengig av båtens størrelse bør reservemotor, årer eller padleåre finnes om bord. Test funksjonen.</p>
		},
		{
			text: 'M. Fortøyningstau',
			legendIcon: 'm',
			modalContent: <p>Minst 4 stk anbefales (tilpasset båtens vekt). Rykkdempere bør finnes, kontroller tilstanden på disse og bytt ved behov.<img src={img2m}/></p>
		},
		{
			text: 'N. Kasteline/redningsline',
			legendIcon: 'm',
			modalContent: <p>Kontroller at den er hel og ser bra ut. OBS: En flytende line, som den skal være, brytes lett ned av sollys. Kun den del som er lysbeskyttet, skal stikke ut av kastposen. Øv på å bruke linen fra tid til annen.<img src={img2n}/></p>
		},
		{
			text: 'O. Kryssholt',
			legendIcon: 'y',
			modalContent: <p>Kontroller at de sitter fast.<img src={img2o}/></p>
		},
		{
			text: 'P. Lanterner',
			legendIcon: 'm',
			modalContent: <p>Kontroller at de fungerer og er riktig montert. Lanternene må ikke blende føreren, og bør kontrolleres i mørket. Ekstra lyspære/LED-lampe anbefales.<img src={img2p}/></p>
		},
		{
			text: 'Q. Motorromsvifte (hvis båt med bensindrevet innenbordsmotor)',
			legendIcon: 'b',
			modalContent: <p>Viktig for å ventilere ut bensindamp og redusere eksplosjonsrisiko. Kontroller at den fungerer. Den skal kjøres i minst 2 minutter før start og alltid ved tanking.</p>
		},
		{
			text: 'R. Stendere, pulpit og grabbrekker. Beskyttelsesnett med hensyn til småbarn og kjæledyr',
			legendIcon: 'y',
			modalContent: <p>Kontroller festene i dekket, at wirene er hele og uskadde, samt at virene som kan åpnes, faktisk kan åpnes.<img src={img2r}/></p>
		},
		{
			text: 'S. Reservekanne',
			legendIcon: 'm',
			modalContent: <p>Kontroller at den er riktig plassert, surret fast og fylt med riktig drivstoff, og at den ikke er for gammel. Kontroller også at reservekannen i plast ikke har passert "siste bruksår".<img src={img2s}/></p>
		},
		{
			text: 'T. Sikker ombord- og ilandstigning',
			legendIcon: 'y',
			modalContent: <p>Kontroller at det er mulig å gå sikkert om bord/iland med tanke på håndtak, grabbrekker, og at man ikke kan skade seg på skarpe, utstikkende detaljer på båten. Gode sko reduserer risikoen for å skli.<img src={img2t}/></p>
		},
		{
			text: 'U. Signalhorn/tut',
			legendIcon: 'm',
			modalContent: <p>Kontroller at det fungerer. Det finnes også håndholdte versjoner.<img src={img2u}/></p>
		},
		{
			text: 'V. Sjøkart',
			legendIcon: 'b',
			modalContent: <p>Kontroller at det er oppdatert for den planlagte ruten.<img src={img2v}/></p>
		},
		{
			text: 'W. Vanntette poser',
			legendIcon: 'b',
			modalContent: <p>Anbefales.<img src={img2w}/></p>
		},
		{
			text: 'X. Bøtter',
			legendIcon: 'm',
			modalContent: <p>Med tau, anbefales. Bra for å øse med, slokke brann eller for andre oppståtte behov og situasjoner.</p>
		},


		{ header: '3. Nødutstyr' },
		{
			text: 'A. Førstehjelpsskrin',
			legendIcon: 'm',
			modalContent: <p>I vanntett pose. Kontroller innholdet og siste utløpsdato.<img src={img3a}/></p>
		},
		{
			text: 'B. Håndlyskaster/strålekaster',
			legendIcon: 'm',
			modalContent: <p>Kontroller at de fungerer.<img src={img3b}/></p>
		},
		{
			text: 'C. Kniv/tau/mykt materiale (for tetting)/vevbåndtape/pluggene i mykt tre',
			legendIcon: 'y',
			modalContent: <p>For reparasjoner osv. Liggeunderlag er nyttig for å lage plugger. Det er lett å rive av til passende størrelser uten å bruke verktøy. Treplugger i riktig dimensjon kan med fordel festes med snøre ved alle gjennomføringer, og er da alltid tilgjengelige i nødsituasjoner. Lett tilgjengelige kniver på strategiske steder som pulpit/pushpit.<img src={img3c}/></p>
		},
		{
			text: 'D. Livbøye',
			legendIcon: 'y',
			modalContent: <p>Med kasteline og lys. Kontroller for nedbrytning av sollys.<img src={img3d}/></p>
		},
		{
			text: 'E. Livbåt',
			legendIcon: 'y',
			modalContent: <p>Kontrolleres, pakkes og surres i henhold til produsentens instrukser.<img src={img3e}/></p>
		},
		{
			text: 'F. Mobiltelefon',
			legendIcon: 'b',
			modalContent: <p>Vanntett og helst med GPS. Last ned SOS Alarm 112-appen og legg inn viktige telefonnumre, som til redningsskøyta. Det er viktig å kontrollere mobiloperatørens dekning.<img src={img3f}/></p>
		},
		{
			text: 'G. Nødraketter/håndbluss',
			legendIcon: 'y',
			modalContent: <p>Ved ferdsel på områder med dårlig mobildekning og åpent vann. Det finnes også LED-nødraketter/håndbluss i dag. Kontroller siste utløpsdato. Utløpte produkter skal returneres til forhandleren.<img src={img3g}/></p>
		},
		{
			text: 'H. Nødsender',
			legendIcon: 'y',
			modalContent: <p>PLB (Personal Locator Beacon), SPOT (Satellite Personal Tracker), EPIRB (Emergency Position Indicating Radio Beacon). Bra å ha på åpent vann og områder med dårlig mobildekning. OBS: Disse må være korrekt registrert for å fungere.<img src={img3h}/></p>
		},
		{
			text: 'I. Reparasjonssett og luftpumpe RIB',
			legendIcon: 'b',
			modalContent: <p>Reparasjon av alvorligere skader bør overlates til fagfolk. Det finnes tetningsbrikkesett for midlertidige reparasjoner hvis det oppstår et hull i en av tubene. Det er to koniske skiver av galvanisert stål som trekkes sammen med en skrue og vingemutter. Brikken tetter rifter på opptil ca. 9 cm i lengde og hull på opptil ca. 6 cm i diameter. Ved limingsreparasjon skal alltid produsentens instruksjoner følges. En feilaktig liming forverrer skaden.</p>
		},
		{
			text: 'J. VHF',
			legendIcon: 'y',
			modalContent: <p>Bra å ha på turer på åpent vann. Bærbar, vanntett VHF kan være et godt supplement eller reserveantenne til fast installert VHF ved eventuelt mastbrudd. Før hver sesong bør en funksjonskontroll gjennomføres ved prøvesending.<img src={img3j}/></p>
		},
		{
			text: 'K. Merking av fartøy',
			legendIcon: 'y',
			modalContent: <p>Det anbefales å merke fartøyene sine, som båt, slepejolle og livbåt. Dette for å kunne kontakte eieren for å sjekke at ingenting har skjedd hvis fartøyet blir funnet drivende uten person om bord.</p>
		},

		{ header: '4. Fremdrift' },
		{
			text: 'A. Eksoslange (ved innenbordsmotor)',
			legendIcon: 'y',
			modalContent: <p>Kontroller at vann ikke kan trenge inn bakfra. Eksosrøret skal gå i en bue opp mot dekk. Den laveste delen av eksoslangen/lyddemperen skal romme det vannet som kan være i systemet når motoren er slått av.</p>
		},
		{
			text: 'B. Akseltetting',
			legendIcon: 'y',
			modalContent: <p>Ved innenbordsmotor med rett aksel. Finnes i ulike utførelser og merker. Kontroller tettheten og servér i henhold til produsentens anbefalinger.<img src={img4b}/></p>
		},
		{
			text: 'C. Verktøy samt brytpinne og tennplugger i reserve',
			legendIcon: 'y',
			modalContent: <p>Brytpinne er vanligvis bare for mindre utenbordsmotorer.</p>
		},
		{
			text: 'D. Belger (motor - drev)',
			legendIcon: 'y',
			modalContent: <p>Kontroller belgene hvert år. Kontroller at slangeklemmene som holder belgen på plass, er tilstrekkelig strammet. Bytt i henhold til produsentens anbefalinger.<img src={img4d}/></p>
		},
		{
			text: 'E. Dødmansgrep/sikkerhetsbryter',
			legendIcon: 'y',
			modalContent: <p>Hvis en slik finnes. Skal stoppe motoren hvis båtfører faller over bord. Viktig at båtfører har den festet, for eksempel rundt armen. Kontroller at den fungerer. En reserve bør være lett tilgjengelig, slik at de som er igjen om bord kan starte motoren hvis føreren har falt over bord.<img src={img4e}/></p>
		},
		{
			text: 'F. Impeller',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov i henhold til motorprodusentens anbefalinger. Ha en i reserve ved lengre turer, for eksempel på åpne farvann. Øv på å bytte den før du faktisk trenger å gjøre det (ved innenbordsmotor). Legg reserveimpelleren i en mørk og tett plastpose, slik at gummiet ikke tørker ut så raskt.<img src={img4f}/></p>
		},
		{
			text: 'G. Motor',
			legendIcon: 'y',
			modalContent: <p>Serve motoren i henhold til instruksjonene fra motorleverandøren.<img src={img3g}/></p>
		},
		{
			text: 'H. Offeranoder',
			legendIcon: 'y',
			modalContent: <p>Kontroller før hver sesong og bytt ved behov. Kan finnes både på motor og aksel, samt på ror og skrog i metall. Kan også finnes i innenbordsmotorens kjølesystem.<img src={img4h}/></p>
		},
		{
			text: 'I. Olje',
			legendIcon: 'm',
			modalContent: <p>I motor, girkasse og drev der det er aktuelt. Kontrolleres ofte.</p>
		},
		{
			text: 'J. Propeller, propelleraksel',
			legendIcon: 'y',
			modalContent: <p>På land – Kontroller at det ikke er noe slark og at det ikke finnes sprekker ved festingen av eventuell støttebukk. Kontroller at bolten som propellen er festet med, er sikret, og at bladene på foldepropellen er ordentlig sikret.<img src={img4j}/></p>
		},
		{
		text: 'K. Sjøvannsfiler (motorkjøling)',
		legendIcon: 'm',
		modalContent: <p>Kontroller og rengjør regelmessig, også i løpet av båtsesongen.<img src={img4k}/></p>
		},


		{ header: '5. Styresystem' },
		{
		text: 'A. Hydraulisk styring',
		legendIcon: 'm',
		modalContent: <p>Kontroller funksjonen og oljenivået. En ekstra flaske med hydraulikkolje er alltid bra å ha med. Undersøk om du kan ordne en reserve-styring ved feil på det ordinære systemet.<img src={img5a}/></p>
		},
		{
		text: 'B. Kompass – fastmontert',
		legendIcon: 'y',
		modalContent: <p>Kontroller når båten ligger stille at det ikke blir forstyrret når rattet vrides eller av elektronisk utstyr, vær spesielt oppmerksom på eventuelle motorer til vindusviskere.<img src={img5b}/></p>
		},
		{
		text: 'C. Styrings- og kontrollwire som passerer gjennom motorrommet',
		legendIcon: 'm',
		modalContent: <p>Kontroller at gjennomføringene er rimelig vannsikre.<img src={img5c}/></p>
		},
		{
		text: 'D. Styring med wirer',
		legendIcon: 'y',
		modalContent: <p>Kontroller at wirene er i god stand og at de ikke går i for skarpe svinger.</p>
		},


		{ header: '6. Elektrisk anlegg' },
		{
		text: 'A. Avansert anlegg bør kontrolleres av fagperson',
		legendIcon: 'y',
		},
		{
		text: 'B. Batterier',
		legendIcon: 'y',
		modalContent: <p>Plassering adskilt fra drivstofftank og godt festet, samt plassert slik at de ikke blir oversvømt av moderate mengder inntrengende vann. Ingen løse gjenstander som kan kortslutte polene skal finnes i samme rom. Sjekk eventuell oksidasjon på polene. Rengjør og smør inn. Det bør alltid finnes en tilgjengelig hovedstrømbryter slik at batteriene kan kobles fra ved elektriske feil. Har båten litiumbatterier, er det viktig å skaffe seg god kunnskap om aktuell type og følge produsentens anbefalinger. Litium har mange fordeler, men skiller seg fra blybatteriers vedlikehold, lagring, lading samt ved skader eller brann. Spesiell lader og et BMS (Battery Management System) kreves, samt at generator / motor er tilpasset. Hvis batterisystemet byttes fra blybatterier til litium, skal arbeidet utføres på en fagmessig måte med relevante regelverk og gjeldende standarder. Feilaktig håndtering eller installasjon kan skade batteriene. Lader for litiumbatterier skal benyttes.<img src={img6b}/></p>
		},
		{
		text: 'C. Elkabler',
		legendIcon: 'y',
		modalContent: <p>Skal være i flertrådet utførelse og dimensjonert i henhold til gjeldende regler for elektrisk installasjon i båt.<img src={img6c}/></p>
		},
		{
		text: 'D. Sikringer i reserve',
		legendIcon: 'y',
		modalContent: <p>Det bør alltid være noen ekstra sikringer ombord for å kunne bytte ut eventuelle som går.</p>
		},


		{ header: '7. Drivstoffanlegg' },
		{
		text: 'A. Drivstoffilter',
		legendIcon: 'y',
		modalContent: <p>Bytt drivstoffilter før hver sesong for å sikre ren drivstofftilførsel og redusere risikoen for motorproblemer. Oppdager du begroing eller urenheter i filteret, kan det være et tegn på at tanken bør rengjøres. Det er lurt å ha et ekstra filter i reserve, selv om båten er utstyrt med et dobbelt filter med omkobling – spesielt ved lengre turer.<img src={img7a}/></p>
		},
		{
		text: 'B. Drivstoffslanger',
		legendIcon: 'y',
		modalContent: <p>Kontroller at drivstoffslangene er av godkjent kvalitet og i god stand. De skal være trukket gjennom gummigjennomføringer der de passerer skott eller andre skarpe kanter, for å unngå slitasjeskader.</p>
		},
		{
		text: 'C. Drivstofftank',
		legendIcon: 'y',
		modalContent: <p>Kontroller før hver sesong tankens tilkoblinger, pakninger og bytt ved behov. Rengjør tanken om nødvendig.<img src={img7c}/></p>
		},
		{
		text: 'D. Vannutskiller (hvis en slik finnes)',
		legendIcon: 'b',
		modalContent: <p>Kontroller at det ikke er lekkasje ved filteret og dets tilkoblinger, samt at de er byttet i henhold til instruksjonene. Tapp ut eventuell vannansamling.<img src={img7d}/></p>
		},


		{ header: '8. Gassanlegg' },
		{
		text: 'A. Gassbeholder',
		legendIcon: 'y',
		modalContent: <p>Skal være plassert stående i et godt ventilert og drenert rom.</p>
		},
		{
		text: 'B. Gasslanger',
		legendIcon: 'y',
		modalContent: <p>Kontroller at de er av godkjent kvalitet og i god stand, og at de er trukket gjennom gummigjennomføringer for å unngå slitasjeskader. Bytt slangene i henhold til produsentens anbefalinger. Gassanlegget har ofte pakninger som bør byttes eller kontrolleres for sprekker.<img src={img8b}/></p>
		},
		{
		text: 'C. Gassregulator',
		legendIcon: 'y',
		modalContent: <p>Kontroller og bytt i henhold til produsentens anbefalinger. Skal være CE-merket for marint bruk.<img src={img8b}/></p>
		},
		{
		text: 'D. Gassvarsler',
		legendIcon: 'y',
		modalContent: <p>Hvis det finnes gass (propan) og/eller varmer ombord, bør det være montert en gassvarsler som varsler for propangass og/eller karbonmonoksid (CO).<img src={img8d}/></p>
		},
		{
		text: 'E. Lekkasjeindikator',
		legendIcon: 'm',
		modalContent: <p>Finnes i forskjellige utførelser. Kontroller at den fungerer som den skal i henhold til produsentens instruksjoner.<img src={img8e}/></p>
		},


		{ header: '9. Toalettsystem med septiktank' },
		{
		text: 'A. Avstengningsventiler toalett og tank',
		legendIcon: 'y',
		modalContent: <p>Kontroller at de er tette og ikke setter seg fast.<img src={img9a}/></p>
		},
		{
		text: 'B. Skroggjennomføringer WC',
		legendIcon: 'm',
		modalContent: <p>Skroggjennomføringer med tilkoblinger for ventiler (=kraner) og slanger. I sjøen – kontroller at det ikke er tegn på lekkasje ved skroggjennomføringen, og at det er helt tørt ved gjennomføringens flensmutter, ventilens gjenger og slangetilkoblinger. Ventilen skal betjenes innimellom for å unngå at den setter seg fast, og den skal være lett å åpne/stenge.<img src={img9b}/></p>
		},
		{
		text: 'C. Om vakuumventil finnes i systemet',
		legendIcon: 'y',
		modalContent: <p>Kontroller at vakuumventilen fungerer.</p>
		}
	]
}

export default motorBatBeregnetForOvernatting